module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project"
  }, [_c('project-header', {
    attrs: {
      "project": _vm.project
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('project-footer', {
    attrs: {
      "prev": "/work/get-clean",
      "next": "/work/clean-sound"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-gallery row"
  }, [_c('div', {
    staticClass: "col-12 project-gallery__img"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12 project-gallery__img"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-5-sm project-gallery__img"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-5-sm project-gallery__img"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12 project-gallery__img project-gallery__img--double"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12 project-gallery__img"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5e5df0fe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/work/HeyStudent.vue
// module id = 390
// module chunks = 2